var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styles from "../HandFilter.module.scss";
import { Radio } from "antd";
import { useComponentLocale } from "../../../hooks/useComponentLocale";
import { allowedAllButton } from "../../constants";
export var HeroVillainSwitcher = function (_a) {
    var filter = _a.filter, onFilterApply = _a.onFilterApply, selectedTab = _a.selectedTab;
    var getLocale = useComponentLocale();
    var heroLocale = getLocale({ component: 'hands', section: 'hero' });
    var villainLocale = getLocale({ component: 'hands', section: 'villain' });
    var allLocale = getLocale({ component: 'tags', section: 'all' });
    var buttons = [
        { id: 'all', name: allLocale, value: null },
        { id: 'hero', name: heroLocale, value: true },
        { id: 'villain', name: villainLocale, value: false },
    ].filter(function (button) { return allowedAllButton.includes(selectedTab) ? true : button.id !== 'all'; });
    var handleSetIsVillain = function (e) {
        if (allowedAllButton.includes(selectedTab)) {
            onFilterApply({
                hero: e.target.value,
            });
        }
        else {
            onFilterApply({
                is_hero: e.target.value,
            });
        }
    };
    return (_jsx("p", { children: _jsx(Radio.Group, __assign({ value: allowedAllButton.includes(selectedTab) ? filter.hero : filter.is_hero, size: 'small', className: styles.radioGroup, onChange: handleSetIsVillain }, { children: buttons.map(function (_a) {
                var name = _a.name, value = _a.value;
                return (_jsx(Radio.Button, __assign({ className: styles.radioButton, value: value }, { children: name }), name));
            }) })) }));
};
